// extracted by mini-css-extract-plugin
export default {"wrapper":"login-page_wrapper__JRBvQ","error":"login-page_error__uOfwb","submit":"login-page_submit__UKV71"};